<template>
  <header class="ohs-header">
    <div class="ohs-logo">
      <a href="http://localhost:8080/our-square">
        <img
          src="https://img-home.csdnimg.cn/images/20201124032511.png"
          alt=""
        />
      </a>
    </div>
    <!-- <div class="menus-box"> -->
    <ul class="ohs-menus">
      <li
        class="ohs-menus-item"
        v-for="(item, index) in headerMenuList"
        :key="index"
      >
        <template>{{ item.label }}</template>
      </li>
    </ul>
    <!-- </div> -->
    <div>
      <el-input size="medium">
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>
    </div>
    <div class="ohs-self">
      <span class="own-space-btn" @click="toOwnSpace">more info</span>
      <img
        class="self-img"
        src="https://img-home.csdnimg.cn/images/20201124032511.png"
        alt=""
      />
    </div>
  </header>
</template>

<script>
export default {
  name: 'ohsHeader',
  props: {
    headerMenuList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    toOwnSpace() {
      this.$router.push({ path: '/own-space' });
    },
  },
};
</script>

<style scoped lang="scss">
.ohs-header {
  display: flex;
  height: 56px;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  background-color: $headerBgColor;
  .ohs-logo {
    height: 100%;
    img {
      height: 100%;
    }
  }
  .ohs-self {
    .own-space-btn {
      cursor: pointer;
      &:hover {
        color: $hoverFontColor;
      }
    }
    .self-img {
      width: 32px;
      height: 32px;
      margin-left: 8px;
      border-radius: 50%;
      vertical-align: middle;
    }
  }
}
.ohs-menus {
  display: flex;
  height: 100%;
  .ohs-menus-item {
    height: 100%;
    padding: 0 5px;
    line-height: 56px;
    cursor: pointer;
    &:hover {
      background-color: $hoverBgColor;
      color: $hoverFontColor;
    }
  }
}
</style>
